const Close = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M8 8L24.9706 24.9706"
        stroke="#222222"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M24.9707 8L8.00014 24.9706"
        stroke="#222222"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export { Close };
